import { Request, Setting } from '../index';

/**
 * 小程序登陆
 * @param params
 * @returns {*|Promise|Promise<unknown>}
 */
const loginWithMiniApp = async params => {
  const gql = `mutation login($form: FormBind!) {
  login {
    userWithCode(form: $form) {
      token
      uid
    }
  }
}`;
  return (await Request.request(gql, params, Setting.modelLogin, '微信登录')).login.userWithCode;
};

/**
 * 用户状态更新
 * @param params
 * @returns {Promise<any>}
 */
const statusUser = async params => {
  const gql = `query statusUser {
  me {
    status {
      token
      exp
      expTime
      uid
      level
      cre
      creTime
      psw
      ip
      id
    }
  }
}`;
  return (await Request.request(gql, params, 'user', '状态验证')).me.status;
};

/**
 * 退出登录
 * @param params
 * @returns {Promise<any>}
 */
const logoutUser = async params => {
  const gql = `mutation logout($agent: String, $dev: String) {
  meExec {
    logout(agent: $agent, dev: $dev)
  }
}`;
  return (await Request.request(gql, params, 'user', '退出登录')).meExec.logout;
};

/**
 * 用户详情
 * @param params
 * @returns {Promise<any>}
 */
const detailUser = async params => {
  const gql = `query detailUser {
  me {
    detail {
      nickname
      createTime
      updateTime
      status
      numAuth
      username
      email
      locNum
      phone
      unique
      source
      statusEmail
      statusPhone
      statusPsw
      statusQuest
      statusCard
      isTwoFactor
      lang
      level
      auth {
        roles {
          key
          name
          desc
          label
        }
        perms {
          key
          name
          desc
          label
        }
        areas {
          key
          cate
          parent
          index
          code
          name
        }
      }
      profile {
        icon
        name
        realName
        phone
        email
        social
        wxIcon
        wxNickname
        wxOpenIdArr
        sex
        birth
        country
        province
        city
        district
        address
        company
        position
        companyID
        companyAddr
        companyHash
      }
      weixin {
        cate
        base {
          unionId
          openId
          nickname
          sex
          province
          city
          country
          icon
        }
        wecom {
          unique
          openId
          userid
          name
          mobile
          email
          avatar
          qrCode
          alias
        }
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'user', '用户详情')).me.detail;
};

/**
 * 更新用户第三方资料
 * @returns {Promise<unknown>}
 */
const updateBindProfile = async params => {
  const gql = `mutation updateBindProfile($form: FormBindProfile!) {
    meEdit {
      updateBindProfile(form: $form) {
        phone
        profile {
          name
          email
          phone
          icon
          sex
          birth
          sign
          country
          province
          city
          district
          address
          realName
          cardId
          passport
          driver
          bankNumber
          ethnic
          religion
          wxIcon
          wxNickname
        }
        weixin {
          base {
            openId
            unionId
          }
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'user', '更新第三方资料')).meEdit.updateBindProfile;
};

/**
 * 更新用户资料
 * @param params
 * @returns {any}
 */
const setProfile = async params => {
  const gql = `mutation setProfile($form: FormUserProfile) {
    meEdit {
      setProfile(form: $form) {
        uid
      }
    }
  }`;
  return (await Request.request(gql, params, 'user', '更新用户资料')).meEdit.setProfile;
};
/**
 * 行政区划
 * @param params
 * @returns {Promise<*>}
 */
const divisionInfo = async params => {
  const gql = `query divisionInfo($form: FormAreaQuery!, $queryArea: FormQuery, $queryStreet: FormQuery, $queryVillage: FormQuery) {
    pub {
      divisionInfo(form: $form) {
        key
        cate
        parent
        index
        createTime
        code
        name
        childList(query: $queryArea) {
          data {
            key
            cate
            parent
            index
            createTime
            code
            name
            childList(query: $queryStreet) {
              data {
                key
                cate
                parent
                index
                createTime
                code
                name
                childList(query: $queryVillage) {
                  data {
                    key
                    cate
                    parent
                    index
                    createTime
                    code
                    name
                  }
                  meta {
                    limit
                    page
                    count
                    num
                  }
                }
              }
              meta {
                limit
                page
                count
                num
              }
            }
          }
          meta {
            limit
            page
            count
            num
          }
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'user', '行政区划')).pub.divisionInfo;
};

//
export default {
  loginWithMiniApp,
  updateBindProfile,
  setProfile,
  divisionInfo,
  //
  statusUser,
  logoutUser,
  detailUser,
};
